module.exports = __webpack_public_path__ + "img/icon-setting-conpon.4796faea.png";